import { render } from "./ProgressPage.vue?vue&type=template&id=da7524be"
import script from "./ProgressPage.vue?vue&type=script&lang=js"
export * from "./ProgressPage.vue?vue&type=script&lang=js"

import "./ProgressPage.vue?vue&type=style&index=0&id=da7524be&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__